import { combineReducers } from "redux";
import authenticationReducer from "../reducers/authentication";
import configurationReducer from "../reducers/config";

export default combineReducers({
  authentication: authenticationReducer,
  configuration: configurationReducer,
});
